<template>
  <div>
    <v-subheader class="px-0 body-2 font-weight-medium" style="cursor: text;">Mis dashboards
      <v-spacer />
      <v-btn class="mt-n1" id="btn-plus" @click="createDashboard()" color="white" fab x-small><v-icon color="secondary" size="20">mdi-plus</v-icon></v-btn>
    </v-subheader>
    <v-skeleton-loader v-if="loading" transition="fade-transition" type="list-item-three-line" />

    <v-list-item class="py-0 pl-4" @click="goToDetails(item.id)" v-else v-for="item in dashboardsList" exact :key="item.id" :ripple="false">
      <v-list-item-title class="subtitle-2 d-inline-block text-truncate" style="max-width: 160px;" >{{item.name}}</v-list-item-title>
    </v-list-item>

    <!-- dialog create -->
    <v-dialog v-model="modalDashboard" :key="updateKey" width="600" persistent no-click-animation>
      <dialog-add-info-dashboard @close="modalDashboard=false" />
    </v-dialog>
    <!-- end dialog create -->

  </div>
</template>
<script>
import { mapState } from 'vuex'

import DialogAddInfoDashboard from '@/components/DialogAddInfoDashboard'

export default {
  components: {
    DialogAddInfoDashboard
  },
  data: () => ({
    modalDashboard: false,
    loading: false,
    updateKey: 0
  }),
  computed: mapState({
    dashboardsList: state => state.dashboards.dashboardsList
  }),
  created () {
    if (!this.dashboardsList.length) {
      this.loading = true
      this.$store.dispatch('dashboards/LIST', {
        resource: 'metrics/dashboards'
      })
      .then(() => {
        this.loading = false
      })
    }
  },
  methods: {
    createDashboard () {
      if (this.dashboardsList.length < 8) {
        this.modalDashboard = true
        this.updateKey += 1
      } else {
        this.$dialog.message.error('Ha alcanzado el limite de dashboards permitidos')
      }
    },
    goToDetails (id) {
      this.$router.push({
        name: 'DashboardUpdate',
        params: {
          id: id
        }
      })
      .catch(err => err)
    }
  }
}
</script>
<style scoped>
#btn-plus {
  box-shadow: 0 1px 3px 0 rgba(59, 59, 88, 0.15) !important;
}
::v-deep .theme--light.v-skeleton-loader .v-skeleton-loader__list-item-three-line {
  background: transparent !important;
}
</style>